import { render, staticRenderFns } from "./content-adjustment.vue?vue&type=template&id=fd3882ee&scoped=true"
import script from "./content-adjustment.vue?vue&type=script&lang=js"
export * from "./content-adjustment.vue?vue&type=script&lang=js"
import style0 from "./content-adjustment.vue?vue&type=style&index=0&id=fd3882ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3882ee",
  null
  
)

export default component.exports